var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3093 42.726C36.2986 41.6248 35.5772 41.7357 35.5772 39.5356C35.5772 38.7656 35.5772 37.3348 35.5772 36.0149C36.6808 34.9152 37.0821 35.0521 38.0153 30.7345C39.9025 30.7345 39.7802 28.5344 40.6703 26.5829C41.3958 24.9936 40.7881 24.3493 40.177 24.086C40.6765 18.2945 40.6766 14.3058 33.3509 13.0684C30.6956 11.0261 26.6887 11.7195 24.7899 12.0603C22.8927 12.4011 21.1814 12.0603 21.1814 12.0603L21.5073 14.8043C18.7291 17.796 20.1184 21.7847 19.6711 24.1209C19.0883 24.4059 18.5625 25.0628 19.2565 26.5829C20.1466 28.5344 20.0243 30.7345 21.9115 30.7345C22.8448 35.0521 23.246 34.9152 24.3497 36.0149C24.3497 37.3348 24.3497 38.7656 24.3497 39.5356C24.3497 41.7357 23.5164 41.7736 21.6177 42.726C17.0399 45.022 11.9016 45.3239 10.8328 52.5C10.637 53.8125 18.2085 59.9955 29.9635 60C41.7185 59.9955 50.1951 52.9792 49.9998 51.6667C48.931 44.4906 42.8324 45.202 38.3093 42.726Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1377a5e9ba2f99976d00f42a58ae3622.svg";
export { ForwardRef as ReactComponent };